import { useLayoutEffect } from 'react'
import { setCommonTrackingParameters } from '../../../tracking/tracking'
import { useHeyImmoExperimentTracking } from './UseHeyImmoExperimentTracking'
import { useRecommendedPriceExperimentTracking } from './UseRecommendedPriceExperimentTracking'

type UseExperimentTrackingParams = {
  recommendedPriceEnabled: boolean
}

export function useExperimentTracking({ recommendedPriceEnabled }: UseExperimentTrackingParams) {
  const heyImmoTrackingParameters = useHeyImmoExperimentTracking()
  const recommendedPriceTrackingParameters = useRecommendedPriceExperimentTracking(recommendedPriceEnabled)
  const commonExperimentTrackingParameters = heyImmoTrackingParameters ?? recommendedPriceTrackingParameters

  useLayoutEffect(() => {
    if (!commonExperimentTrackingParameters) {
      return
    }

    setCommonTrackingParameters(commonExperimentTrackingParameters)

    return () => {
      setCommonTrackingParameters()
    }
  }, [commonExperimentTrackingParameters])
}
